import { render, staticRenderFns } from "./calendar-edit-attributes-form.vue?vue&type=template&id=5762bda5&scoped=true"
import script from "./calendar-edit-attributes-form.vue?vue&type=script&lang=js"
export * from "./calendar-edit-attributes-form.vue?vue&type=script&lang=js"
import style0 from "./calendar-edit-attributes-form.vue?vue&type=style&index=0&id=5762bda5&lang=scss&scoped=true"
import style1 from "./calendar-edit-attributes-form.vue?vue&type=style&index=1&id=5762bda5&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5762bda5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\User\\Documents\\legalmerge-prod\\legal-merge\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5762bda5')) {
      api.createRecord('5762bda5', component.options)
    } else {
      api.reload('5762bda5', component.options)
    }
    module.hot.accept("./calendar-edit-attributes-form.vue?vue&type=template&id=5762bda5&scoped=true", function () {
      api.rerender('5762bda5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin_settings/components/calendars/calendar-edit-attributes-form.vue"
export default component.exports